<template lang="pug">
div(style="padding: 0 25px;")
    router-link(to="/edicao-simplificada" style="display: block; width: fit-content;")
      md-button.access-workspace.fixed-button
        v-icon(aria-hidden="false") mdi-arrow-left
        | {{ $t('simplifiedEditing.backToWorkspace') }}
    BotPageTitle(style="margin: 30px 0 0 -2px; padding: 0; font-size: 53px; font-weight: 400; text-align: left; color: #515151;")
    h3(:style="{ fontSize: $vuetify.breakpoint.xsOnly ? '25px' : '' }" style="margin: 0; font-weight: 400; color: #515151")
      | {{ $t('simplifiedEditing.subtitle.chooseVersion') }}
      br
      | {{ $t('simplifiedEditing.subtitle.limitedEditing') }}
    p(style="margin: 0;")
      | OBS: {{ $t('simplifiedEditing.observation') }}
    div.md-layout(style="padding-left: 0;")
      v-progress-circular(
        v-if="loading"
        size='120'
        width='4'
        style="padding:0 30px; margin: 55px 0 0 0; width: 100px;"
        indeterminate
        color='rgba(200, 200, 200, 0.7)')
      md-card(v-else style="padding:0 30px; margin: 55px 0 0 0; width: fit-content; min-width: 346px; position: static")
        md-card-header.md-card-header-icon.md-card-header-green
          div.card-icon(v-if='latestSnapshotState === "checkedout"')
            EditSquare.item-size
          div.card-icon(v-else)
            v-icon check
          h4.title(style="font-weight: 700; font-size: 20px;") {{ cardTitle }}
        md-card-content
          div.card-info
            p
              b {{ $t('simplifiedEditing.id') }}:{{ ' ' }}
              span {{ snapshotData.id }}
            p
              b {{ $t('commonWords.description') }}:{{ ' ' }}
              span {{ snapshotData.description }}
          div.card-info
            p
              b {{ $t('commonWords.updatedBy') }}:{{ ' ' }}
              span {{ snapshotData.updatedBy }}
            p
              b {{ $t('commonWords.updatedAt') }}:{{ ' ' }}
              span {{ snapshotData.updatedAt }}
          div.card-info
            p
              b {{ $t('selectSnapshot.lastEditor') }}:{{ ' ' }}
              span {{ snapshotData.lastEditor }}
            p
              b {{ $t('selectSnapshot.updatedTo') }}:{{ ' ' }}
              span {{ snapshotData.updatedTime }}
          div.card-info
            p
              b {{ $t('commonWords.actions') }}
            div.card-actions
              span
                v-btn(x-small, fab, depressed, color="#20A6E5" @click="changeMethod('view')"
                  :disabled="!(allowedToEdit && validateRoles('view'))")
                  v-icon(dark) visibility
                  md-tooltip(md-direction="bottom") {{ $t('snapshots.toView') }}
              span
                v-btn(x-small, fab, depressed, color="#F19D38" @click="changeMethod('edit')"
                  :disabled=" !(allowedToEdit && validateRoles('edit'))")
                  v-icon(dark) create
                  md-tooltip(md-direction="bottom") {{ $t('snapshots.editWorkspace') }}
              span(v-if='latestSnapshotState === "checkedout"')
                v-btn(x-small, fab, depressed, color="#31A44C" @click="changeMethod('publish')"
                  :disabled=" !(allowedToEdit && validateRoles('publish') && hasChanges)")
                  PublishIcon(class="icon-size")
                  md-tooltip(md-direction="bottom") {{ $t('snapshots.publish') }}
              span
                v-btn(x-small, fab, depressed, color="#9346A4" @click="changeMethod('download')"
                  :disabled=" !(allowedToEdit && validateRoles('download'))")
                  v-icon(dark) mdi-download
                  md-tooltip(md-direction="bottom") {{ $t('snapshots.download') }}
              span(v-if='latestSnapshotState === "checkedout"')
                v-btn(x-small, fab, depressed, color="#009886" @click="changeMethod('viewPublishedVersion')"
                  :disabled="!validateRoles('viewPublishedVersion')")
                  PreviewIcon(class="icon-size")
                  md-tooltip(md-direction="bottom" bottom) {{ $t('snapshots.viewPublishedVersion') }}
              span
                v-btn(x-small, fab, depressed, color="#000699" @click="changeMethod('import')" :disabled="!(allowedToEdit && validateRoles('publish'))"
                  )
                  v-icon(dark) mdi-file-upload-outline
                  md-tooltip(md-direction="bottom") {{ $t('snapshots.importFromAJsonFile') }}
    SimplifiedEditModal(
      :showModal.sync="showModal"
      max-width='508px'
      scrollable
      headerColor="none"
      lButtonColor='#F44336'
      rButtonColor='#4CAF50'
      :lButtonTitle="$t('commonWords.no')"
      @clickLButton='showModal = false'
      showRButton
      showLButton
      :rButtonTitle="$t('commonWords.yes')"
      @clickRButton='handleActions'
    ).radius
      template(slot='content')
        v-col
          v-row(style='justify-content: center;')
            AlertCircle
          v-row
            h2.modal-title {{ title }}
            h3.modal-subtitle {{ subtitle }}
    v-fade-transition
     v-overlay(:value="publishing")
        v-progress-circular(style="display: inline-block; width: 100%;" indeterminate size="64")
        div(style="display: inline-block; width: 100%;" class="h2 font-weight-thin") {{ loadingText }}
    v-dialog(
      content-class="import-dialog"
      v-model="showImportDialog"
      max-width="1200px"
      :scrollable="true"
    )
      ImportWorkspace(
        v-if="showImportDialog"
        :importType="'json'"
        @close-dialog="showImportDialog = false"
        @finish-import="finishImport"
      )

</template>

<script>
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import BotPageTitle from '@/components/BotPageTitle.vue'
import ImportWorkspace from '@/components/WorskspaceImportDialogs/ImportWorkspace.vue'

import PublishIcon from '@/assets/img/publish.svg'
import PreviewIcon from '@/assets/img/preview.svg'
import AlertCircle from '@/assets/img/alert-circle.svg'
import EditSquare from '@/assets/img/edit_square.svg'
import SimplifiedEditModal from '@/components/SimplifiedChatbuilder/SimplifiedEditModal.vue'
import Swal from 'sweetalert2'
import moment from 'moment'
import { selectedLocale } from '@/plugins/i18n'

export default {
  data () {
    return {
      title: '',
      subtitle: '',
      loading: false,
      publishing: false,
      loadingText: '',
      showModal: false,
      showImportDialog: false,
      allowedToEdit: false,
      itemClicked: null,
      allNodesHistory: [],
      dialogs: {
        view: false,
        edit: false,
        publish: false,
        preview: false,
        viewCurrentPublished: false
      },
      method: null,
      snapshotData: {
        id: '',
        description: '',
        updatedBy: '',
        updatedAt: '',
        lastEditor: '',
        updatedTime: ''
      }
    }
  },
  components: {
    SimplifiedEditModal,
    BotPageTitle,
    PublishIcon,
    PreviewIcon,
    AlertCircle,
    EditSquare,
    ImportWorkspace
  },
  computed: {
    cardTitle () {
      return this.latestSnapshotState === 'checkedout' ? this.$t('simplifiedEditing.editedVersion') : this.$t('simplifiedEditing.publishedVersion')
    },
    isLatestSnapshotPublished: {
      get () {
        return this.latestSnapshotState === 'published'
      },
      set () {

      }
    },
    ...mapGetters('auth', ['user']),
    ...mapFields('selectedAssistant', ['assistantId', 'workspaceActiveId']),
    ...mapGetters('snapshots', {
      snapshots: 'snapshots',
      appliedSnapshot: 'appliedSnapshot',
      hasChanges: 'hasChanges',
      latestSnapshotState: 'latestSnapshotState',
      viewingMode: 'viewingMode',
      importSimplifiedEditing: 'importSimplifiedEditing'
    })
  },
  async created () {
    await this.getSnapshots()
  },
  methods: {
    async handleActions () {
      if (this.method === 'edit' || this.method === 'view') {
        this.$store.commit('snapshots/setViewingMode', this.method === 'view')

        if (this.method === 'edit' && this.latestSnapshotState === 'published') {
          this.loadingText = this.$t('commonWords.loading')
          this.showModal = false
          this.publishing = true
          await this.$axios.post(`/chatbuilder/${this.workspaceActiveId}/checkout`)
          await this.getSnapshots()
          this.publishing = false
        }
        await this.$router.push('/chatbuilder')
      }
      if (this.method === 'viewPublishedVersion') {
        this.$store.dispatch('snapshots/applySnapshot', this.appliedSnapshot)
        this.$router.push('/chatbuilder')
      } else if (this.method === 'download') {
        this.downloadWithAxios(`/snapshots/${this.snapshotData.id}/download`)
      } else if (this.method === 'publish') {
        await this.publishSnapshot()
      } else if (this.method === 'import') {
        this.$store.commit('snapshots/setImportSimplifiedEditing', true)
        this.showModal = false
        this.showImportDialog = true
      }
    },
    forceFileDownload (response, title) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
    },
    downloadWithAxios (url) {
      const title = this.snapshotData?.description ? `${this.snapshotData.description}.json` : 'snapshot.json'
      this.$axios({
        method: 'get',
        url,
        responseType: 'arraybuffer',
        header: {}
      })
        .then((response) => {
          this.forceFileDownload(response, title)
        })
    },
    async changeMethod (method) {
      this.resetDialogs()
      this.method = method
      if (method === 'view') {
        this.showModal = true
        this.dialogs.view = true
        this.$store.commit('snapshots/setViewingMode', true)
        this.title = this.$t('snapshots.visualizeModalConfirmationTitle')
        this.subtitle = ''
      } else if (method === 'edit') {
        this.showModal = true
        this.dialogs.edit = true
        this.$store.commit('snapshots/setViewingMode', false)
        this.title = this.$t('snapshots.editModalConfirmationTitle')
        this.subtitle = this.$t('snapshots.editModalConfirmationSubtitle')
      } else if (method === 'publish') {
        this.showModal = true
        this.title = this.$t('snapshots.areYouSureYouWantToPublishThisVersion')
        this.subtitle = ''
      } else if (method === 'viewPublishedVersion') {
        this.title = this.$t('snapshots.viewPublishedVersionTitle')
        this.showModal = true
        this.dialogs.viewCurrentPublished = true
        this.$store.commit('snapshots/setViewingMode', true)
      } else if (method === 'download') {
        this.handleActions()
      } else if (method === 'import') {
        this.showModal = true
        this.title = 'Você tem certeza que deseja importar essa versão?'
        this.subtitle = 'A versão publicada será substituída por esta nova versão, e uma nova edição será gerada.'
      }
    },
    resetDialogs () {
      this.dialogs.view = false
      this.dialogs.edit = false
      this.dialogs.publish = false
      this.dialogs.preview = false
      this.dialogs.viewCurrentPublished = false
      this.title = ''
      this.subtitle = ''
    },
    validateRoles (action) {
      if (this.user) {
        const viewerPermissions = ['chatbuilder-view']
        const editorPermissions = [...viewerPermissions, 'chatbuilder-edit']
        const adminPermission = [...editorPermissions, 'chatbuilder-publish']

        if (this.user.roles === 'Administrador') {
          return true
        }

        if (action === 'view') {
          return this.contains(viewerPermissions, this.user?.functions)
        } else if (action === 'edit') {
          return this.contains(editorPermissions, this.user?.functions)
        } else if (action === 'publish') {
          return this.contains(adminPermission, this.user?.functions)
        } else if (action === 'download') {
          return this.contains(viewerPermissions, this.user?.functions)
        } else if (action === 'viewPublishedVersion') {
          return this.contains(viewerPermissions, this.user?.functions)
        }
      }
    },
    contains (array1, array2) {
      if (Array.isArray(array2)) {
        return array1?.every(element => array2?.includes(element))
      }
      return false
    },
    async publishSnapshot () {
      try {
        this.loadingText = this.$t('snapshots.publishingVersion')
        this.publishing = true
        this.showModal = false
        const workspaceId = this.$store.getters['selectedAssistant/workspaceActiveId']
        await this.$store.dispatch('snapshots/publishSimplifiedEditing', {
          _id: this.snapshotData.id
        })
        await this.startPulling(this.snapshotData?.id, workspaceId)
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: this.$t('snapshots.errorPublishingWorkspace'),
          html: error
        })
      }
    },
    async startPulling (snapshotId, workspaceId) {
      try {
        this.interval = setInterval(async () => {
          await this.getModelStatusByTaskId(snapshotId, workspaceId).then(response => {
            const clearStatusLabels = ['complete', 'failed', 'published', 'skipped']
            if (clearStatusLabels.includes(response?.data?.status)) {
              this.getSnapshots()
              clearInterval(this.interval)
              this.$store.commit('snapshots/latestSnapshotState', 'published')
              this.$store.commit('snapshots/setHasChanges', false)
              Swal.fire({
                icon: 'success',
                timer: 5000,
                title: this.$t('snapshots.workspacePublishedSuccessfully')
              })
              this.publishing = false
              this.$forceUpdate()
            }
          })
        }, 10000)
      } catch (error) {
        clearInterval(this.interval)
        this.publishing = false
        Swal.fire({
          icon: 'error',
          title: this.$t('snapshots.thereWasAnErrorInYourRequest')
        })
      }
      this.loading = false
    },
    async getModelStatusByTaskId (snapshotId, workspaceId) {
      try {
        return this.$axios.get(`/chatbuilder/${snapshotId}/workspace/${workspaceId}/status`)
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: this.$t('snapshots.thereWasAnErrorInYourRequest')
        })
      }
    },
    async getSnapshots () {
      try {
        this.loading = true
        const result = await this.$store.dispatch('snapshots/populate', {
          page: 0,
          perPage: 10
        })

        let data = {}

        const checkedoutSnapshot = result?.data?.find(snapshot => snapshot._source.status === 'checkedout')
        if (checkedoutSnapshot) {
          data = {
            id: checkedoutSnapshot._id,
            description: checkedoutSnapshot._source.description,
            updatedBy: checkedoutSnapshot._source.updatedBy.name,
            updatedAt: moment(checkedoutSnapshot._source.updatedAt).locale(selectedLocale).fromNow(),
            lastEditor: checkedoutSnapshot._source.updatedBy.name,
            updatedTime: moment(checkedoutSnapshot._source.updatedAt).locale(selectedLocale).fromNow()
          }

          const timePassed = moment().isSameOrAfter(moment(checkedoutSnapshot._source.updatedAt).add(1, 'hours'))
          this.allowedToEdit = timePassed || checkedoutSnapshot._source.updatedBy.id === this?.user?.id
          this.snapshotData = data
          this.$store.commit('snapshots/latestSnapshotState', 'checkedout')
        } else {
          const displayedSnapshots = result?.data?.find(snapshot => snapshot._source.status === 'published')
          data = {
            id: displayedSnapshots._id,
            description: displayedSnapshots._source.description,
            updatedBy: displayedSnapshots._source.updatedBy.name,
            updatedAt: moment(displayedSnapshots._source.updatedAt).locale(selectedLocale).fromNow(),
            lastEditor: displayedSnapshots._source.updatedBy.name,
            updatedTime: moment(displayedSnapshots._source.updatedAt).locale(selectedLocale).fromNow()
          }
          this.$store.commit('snapshots/latestSnapshotState', 'published')
          this.allowedToEdit = true
          this.snapshotData = data
        }

        this.$store.commit('snapshots/selectedSnapshot', data)
        this.loading = false
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: this.$t('testNotificationDialog.thereWasAnErrorInYourRequest')
        })
      }
    },
    async finishImport (data, callback) {
      const workspace =
        data.workspace ||
        this.$store.getters['selectedAssistant/workspaceActiveId']

      const snapshotData = JSON.parse(data.json)

      try {
        const checkedoutSnap = this.$store.getters['snapshots/checkedOut']
        if (data.edit.importType === 'checkedout' && checkedoutSnap) {
          await this.$axios.delete(`/snapshots/${checkedoutSnap._id}`)
        }
        const result = await this.$axios.post('/snapshots', {
          workspace,
          data: snapshotData,
          description: data.edit.description,
          status: data.edit.importType
        })
        if (data.edit.importType === 'checkedout') {
          this.$store.commit('snapshots/setViewingMode', false)
          this.$store.commit('snapshots/setAppliedSnapshot', result?.data)
        }
        this.$store.commit('snapshots/setHasChanges', true)
        callback(null, result)
      } catch (e) {
        const errorMessageMap = {
          500: this.$t('snapshots.internalErrorContactYourAdministrator'),
          403: this.$t('snapshots.youAreNotAllowedToPerformThisOperation'),
          404: this.$t('snapshots.notFound'),
          401: this.$t('snapshots.youAreNotAuthenticatedPleaseLogin'),
          422: this.$t('snapshots.thereWasAnErrorInYourRequest')
        }
        if (e.isAxiosError) {
          callback(new Error(errorMessageMap[e.response.status]))
        } else {
          callback(new Error(errorMessageMap[500]))
        }
      }
      this.$store.commit('snapshots/setImportSimplifiedEditing', false)
      this.getSnapshots()
    }
  }
}
</script>

<style lang="scss" scoped>
.fixed-button {
  position: relative;
  top: 0px;
  display: flex;
  justify-content: center;
  gap: 14px;
}

.access-workspace {
  background-color: #6BA652 !important;
  color: #fff !important;
  margin-top: 20px;
  font-weight: 400;
  font-size: 14px;
  border-radius: 6px;

  &:hover, &:focus, &:active, &:active:focus {
    background-color: #4C8342 !important;
  }
}

.card-info {
  margin-bottom: 20px;

  & b {
    font-weight: 700;
  }
}

.card-actions {
  display: flex;
  gap: 10px;
}

.modal-title {
  padding-top: 20px;
  font-weight: 600;
  font-size: 32px;
  line-height: 37.5px;
  text-align: center;
}

.modal-subtitle {
  font-size: 16px;
  line-height: 18.75px;
  text-align: center;
}

.card-actions i {
  color: #FFFFFF !important;
}

.radius {
  border-radius: 50px;
}

.item-size {
  width: 32px;
  height: 32px;

  & svg {
    font-size: 32px;
  }
}

.icon-size {
  width: 16px;
  height: 16px;
  margin: 4.5px 0;

  & svg {
    width: 16px;
    height: 16px;
  }
}
</style>
